/**
 * Shared panel-background tints — matches the target design system's
 * `ToolFrame.jsx` `SURFACE` map (bare `--muted`/`--card` there; this app's
 * real tokens are `--color-*`-prefixed, see `design_system/CLAUDE.md`'s
 * naming-convention exception table). `records` is the untinted value
 * (identical to a plain `--color-card` background) — pass it explicitly to
 * opt a panel OUT of the `detail` tint that `EditPanel` now defaults to.
 */
export const SURFACE = {
  records: 'var(--color-card)',
  detail: 'color-mix(in srgb, var(--color-muted) 34%, var(--color-card))',
  aside: 'color-mix(in srgb, var(--color-muted) 62%, var(--color-card))',
} as const;

export type SurfaceName = keyof typeof SURFACE;
